import { render } from "./AdminBillsView.vue?vue&type=template&id=3e7caa9f&ts=true&lang=pug"
import script from "./AdminBillsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminBillsView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__